import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../services/homphyApi';

type Result = { valid: boolean; receiptNumber: string | null; sessionDate: string | null; providerName: string | null };

export default function SessionReceiptVerify() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [input, setInput] = useState(code || '');
  const [result, setResult] = useState<Result | null>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    if (!meta) { meta = document.createElement('meta'); meta.name = 'robots'; document.head.appendChild(meta); }
    meta.content = 'noindex, nofollow';
    let referrer = document.querySelector('meta[name="referrer"]') as HTMLMetaElement | null;
    if (!referrer) { referrer = document.createElement('meta'); referrer.name = 'referrer'; document.head.appendChild(referrer); }
    const previousReferrer = referrer.content;
    referrer.content = 'no-referrer';
    document.title = 'Verify session receipt | Homphy';
    return () => { meta!.content = 'index, follow'; referrer!.content = previousReferrer; };
  }, []);
  useEffect(() => { if (code) void verify(code); }, [code]);
  const verify = async (value: string) => {
    setBusy(true); setResult(null);
    try { setResult(await api.get<Result>(`/session-receipts/verify/${encodeURIComponent(value.trim())}`)); }
    catch { setResult({ valid: false, receiptNumber: null, sessionDate: null, providerName: null }); }
    finally { setBusy(false); }
  };
  return <main style={{ maxWidth: 520, margin: '48px auto', padding: 24 }}>
    <h1>Session receipt verification</h1>
    <p>This confirms a session took place. It does not confirm any payment.</p>
    <form onSubmit={e => { e.preventDefault(); if (input.trim()) navigate(`/verify/${encodeURIComponent(input.trim())}`); }}>
      <label htmlFor="receipt-code">Verification code</label>
      <input id="receipt-code" value={input} onChange={e => setInput(e.target.value)} autoComplete="off" style={{ display: 'block', width: '100%', padding: 12, margin: '8px 0' }} />
      <button type="submit" disabled={busy || !input.trim()}>{busy ? 'Checking…' : 'Verify receipt'}</button>
    </form>
    {result && (result.valid
      ? <section aria-live="polite"><h2 style={{ color: '#16803c' }}>Valid session receipt</h2><p>Receipt: {result.receiptNumber}</p><p>Date: {result.sessionDate}</p><p>Provider: {result.providerName}</p></section>
      : <p aria-live="polite">This receipt could not be verified</p>)}
  </main>;
}
